<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Акции</strong>
                </CCardHeader>
                <CCardBody>
                    <div class="overflow-hidden border border-gray-300 rounded-md">
                        <div class="flex items-center bg-gray-100">
                            <div class="w-3/12 py-2 px-2 font-bold">Название</div>
                            <div class="w-3/12 py-2 font-bold">Количество заказов</div>
                            <div class="w-3/12 py-2 font-bold">Скидка (%)</div>
                            <div class="w-2/12 py-2 font-bold">Тип доставки</div>
                            <div class="w-3/12 py-2 px-2 font-bold">Учитывать при интеграции</div>
                            <div class="w-3/12 py-2 font-bold">Активен</div>
                        </div>

                        <div
                            v-for="item in list"
                            :key="item.id"
                            class="flex items-center h-10 py-4 border-t border-gray-300"
                        >
                            <div class="w-3/12 truncate px-2">
                                <span
                                    class="text-purple-700 cursor-pointer hover:underline"
                                    @click="$router.push(`promotions/${item.id}`)"
                                >
                                    {{ item.title }}
                                </span>
                            </div>

                            <div class="w-3/12 py-2">{{ item.orders_quantity }}</div>
                            <div class="w-3/12 py-2">{{ item.discount }}%</div>

                            <div class="w-2/12 py-2">
                                {{ labelDeliveryType(item.delivery_type) }}
                            </div>

                            <div class="w-3/12">
                                <CBadge :color="item.accounting_in_integration ? 'success' : 'secondary'">
                                    {{ item.accounting_in_integration ? "Да" : "Нет" }}
                                </CBadge>
                            </div>

                            <div class="w-3/12">
                                <CBadge :color="item.enabled ? 'success' : 'secondary'">
                                    {{ item.enabled ? "Да" : "Нет" }}
                                </CBadge>
                            </div>
                        </div>
                    </div>
                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="$router.push('promotions/create')"
                    >Создать</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    const { formatDate } = require('../../../utils/views');
    const { DELIVERY_TYPE } = require('../../../utils/order');

    export default {
        name: 'CommonPromotions',

        components: {},

        data() {
            return {
                list: [],
            };
        },

        computed: {},

        watch: {},

        async created() {
            await this.fetchList();
        },

        methods: {
            async fetchList() {
                const response = await this.axios.get('/common-promotions');
                this.list = response.data;
            },
            formatDate(date) {
                return formatDate(date);
            },

            labelDeliveryType (delivery_type) {
                const types = [];
                types.push({ value: DELIVERY_TYPE.DOOR, label: 'До двери' });
                types.push({ value: DELIVERY_TYPE.MEETING_POINT, label: 'Место встречи' });
                types.push({ value: DELIVERY_TYPE.WITHOUT, label: 'Без доставки' });
                types.push({ value: DELIVERY_TYPE.COLLECT, label: 'Сборка заказа' });

                for (const type of types) {
                    if(delivery_type === type.value){
                        return type.label;
                    }
                }
                return '';
            },
        },
    };
</script>
